import { SharePermission } from "./Task";

export const emptyUsersGroup: UsersGroup = {
    _id: '',
    name: '',
    description: '',
    members: []
}

export interface GroupMember {
    user: string;
    permission: SharePermission;
}

export interface GroupMemberWithDetails {
    user: {
        _id: string;
        email: string;
        profile?: {
            name?: string;
            firstname?: string;
            lastname?: string;
        }
    };
    permission: SharePermission;
}

export interface UsersGroup {
    _id: string;
    name: string;
    description: string;
    members: GroupMember[];
}

// For display in the UI
export interface GroupMemberDisplay {
    id: string;
    email: string;
    name: string;
    label: string;
    permission: SharePermission;
}
